import { Container, Row } from "react-grid-system";
import JobKanbanView from "../../components/JobKanbanView";
import { StyledHome } from "./Home.styles";
import { useStoreActions } from "../../store";
import { useEffect } from "react";
import { HeaderMode } from "../../types/HeaderMode";

export const Home: React.FC = () => {

  const { appSettings } = useStoreActions((actions) => actions);

  useEffect(() => {
    appSettings.setHeaderMode(HeaderMode.Home);
  }, []);

  return (
    <StyledHome>
      <Container fluid>
        <Row>
          <JobKanbanView />
        </Row>
      </Container>
    </StyledHome>
  );
};
